<template>
    <div class="fullScreen">
        <div class="fullScreen-item">
            <component :is="getComponents" :fullStatus="true"></component>
        </div>
    </div>
</template>
<script>
import EquityChart from './profitability/sig-single-chart-grid';
import GridCharts from './profitability/sig-chart-grid';
import StrategyChart from './profitability/chartsForTabs/pofitInPercent/sig-profit-chart-strategy-widget'
import WeekChart from './profitability/chartsForTabs/profitWeekCharts/widgetWeekWrapper'
import MonthChart from './profitability/chartsForTabs/profitMonthCharts/widgetMonthWrapper'
import GridStrategy from './profitability/profit-strategy/grid-charts'
import DayChart from './profitability/chartsForTabs/profitDayCharts/widgetWrapper'
import Gistogramma from './statistica/sig-year-profit-gistagram'
import Prognosis from './profitability/sig-chart-widget-progosis'
export default {
    components: {
        'chart':EquityChart,
        'grid':GridCharts,
        'strategy':StrategyChart,
        'week':WeekChart,
        'gridSt':GridStrategy,
        'month':MonthChart,
        'dayChart':DayChart,
        'gistogramm':Gistogramma,
        'prognosis':Prognosis
    },
    data() {
        return {
            components: [
                'chart', 'grid'
            ]
        }
    },
    computed: {
        getComponents() {
            return this.chart;
        }
    },
    props: ['chart']
}
</script>
<style lang="less" scoped>
.fullScreen {
    position: absolute;
    top:0;
    left:0;
    max-width: 100vw;
    max-height: 100vh;
    overflow: hidden;
    display: block;
    background: #000;
    z-index: 10;
    &-item {
        height: 100vh;
        width: 100vw;
        display: flex;
    }
}
</style>
